/** Multiplayer pose sync — timing and wire types (client + server). */

export const PLAYER_POSE_MIN_INTERVAL_MS = 50;
export const PLAYER_POSE_MIN_MOVE_PX = 4;
export const PEER_INTERPOLATION_BACKTIME_MS = 90;
export const PEER_POSE_LERP_PER_MS = 0.018;
export const PEER_POSE_BUFFER_MAX = 12;
/** Teleport peer rig if interpolation target is farther than this (catch-up after tab-out / zone). */
export const PEER_SNAP_DISTANCE_PX = 128;

export const GAME_ZONES = ["downtown", "maple_heights"] as const;
export type GameZoneId = (typeof GAME_ZONES)[number];

/** Client → server `game:player_move` body (userId added by server on relay). */
export type GamePlayerPoseClientPayload = {
  sessionId: string;
  x: number;
  y: number;
  zone: GameZoneId;
  /** When in a building interior; null/omitted when outdoors. */
  buildingId?: string | null;
  facing: string;
  seq?: number;
  clientSentAtMs?: number;
};

/** Server → clients relayed pose. */
export type GamePlayerPoseRelayPayload = GamePlayerPoseClientPayload & {
  userId: string;
  serverSentAtMs: number;
};

/** Join snapshot for late entrants (`game:player_snapshot`). */
export type GamePlayerSnapshotPayload = {
  sessionId: string;
  poses: GamePlayerPoseRelayPayload[];
};

export function isGameZoneId(z: string): z is GameZoneId {
  return z === "downtown" || z === "maple_heights";
}
